import cn from 'classnames';
import { ReactNode } from 'react';
import { useBpmNavigate } from '@src/utils/routing/useBpmNavigate';
import { FullNavGroup, LocationType } from '@src/utils/routing/location-constants';
import { useCompanyInfo } from '@src/utils/hooks/useCompanyInfo';
import { useLocation } from 'react-router-dom';
import { Appearance, Background, Size } from '../designConstants';
import { IconButton } from '../IconButton';

interface DirectNavLinkProps {
  navGroup: FullNavGroup;
}

export const DirectNavLink = ({ navGroup }: DirectNavLinkProps): ReactNode => {
  const navigate = useBpmNavigate();
  const { pathname } = useLocation();
  const { cid } = useCompanyInfo();
  const { key, prettyName, icon: Icon, items } = navGroup;

  const activeItem = cid
    ? (items.find(item => item.type === LocationType.Client) ?? items[0])
    : items[0];
  const { type, fullPath } = activeItem;

  const isActive = items.some(item => {
    const resolvedPath =
      item.type === LocationType.Client && cid ? `/${cid}${item.fullPath}` : item.fullPath;
    return pathname === resolvedPath || pathname.startsWith(`${resolvedPath}/`);
  });

  return (
    <div data-testid={`nav-group-${key}`} className='nav-group-container'>
      <IconButton
        name={`${key}-nav-group-icon`}
        className={cn('nav-group-icon', {
          active: isActive
        })}
        appearance={Appearance.EMPTY}
        background={Background.DARK}
        size={Size.LG}
        onClick={() => navigate({ type, path: fullPath.slice(1), prettyName })}
      >
        <Icon color='white' />
      </IconButton>
    </div>
  );
};
